import React, { useCallback, useContext, useEffect, useState } from 'react';
import { req } from 'src/api/rest/core';
import { apiHost } from 'src/env';
import { IUserInfo } from 'src/lib/types/user-info';

const LOG_PREFIX = '@zoomex-growth-activity/biz-components/userinfo';

/**
 * Request handler for fetch user info
 */
export const getUserInfo = () => {
  return req(
    `${apiHost}/v2/private/user/profile`,
    {},
    { method: 'GET', hideToast: true, isRefresh: true }
  );
};

/**
 * React Context for UserInfo
 */
export const UserInfoContext = React.createContext({
  userInfo: undefined,
  isLogin: false,
  setUserInfo: () => {
    return;
  },
  isFetched: false,
});
UserInfoContext.displayName = 'UserInfoContext';

/**
 * Custom React Context Provider for providing get/set user info and check user has logined or not
 * @param param0 Object props
 */
export const UserInfoProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState<IUserInfo>();
  const [isFetched, setFetched] = useState(false);

  const fetchUserInfo = useCallback(
    async (response?: any, cb?: (r: number | undefined) => void) => {
      try {
        let res: any = null;
        if (!response) {
          const resp = await getUserInfo();
          res = resp.result;
        } else {
          res = response;
        }
        setUserInfo(res);

        // @todo: for check app login status issue, remove in the future,
        // console.log('getUserInfo', response);

        // set GA_UID for make sure u with data
        if (res) {
          window.GA_UID = res.id || 0;
        }
        cb?.(res.id);
      } catch (e) {
        console.error(`${LOG_PREFIX} fetch result: Fail to get user info`, e);
        cb?.(undefined);
      }
      setFetched(true);
    },
    []
  );

  useEffect(() => {
    //fetchUserInfo();
  }, []);

  return (
    <UserInfoContext.Provider
      value={{
        userInfo,
        isLogin: userInfo && userInfo.id > 0,
        setUserInfo: fetchUserInfo,
        isFetched,
      }}
    >
      {children}
    </UserInfoContext.Provider>
  );
};

export default UserInfoContext;

/**
 * Custom React Hooks
 */
export const useUserInfo = () => {
  const context = useContext(UserInfoContext);
  return context;
};
